<!-- Navbar -->
<div class="bg-white">

  <HomeNavBar />

  <!-- Hero Section -->
  <section>
    <div class=" mt-5">
      <div class="container">
        <div class="row">
          <div class="justify-content-center text-center col-md-8 mx-auto">
            <h3 class="mb-2 fw-bold">Empowering Women, Youth and Persons with Disabilities</h3>
            <p class="mb-4">Leading socio-economic transformation through evidence-based monitoring,
              advocacy, and inclusion—building
              a society free from discrimination where everyone can thrive.</p>
            <a href="#knowledgehub-cards" class="btn knowledgehub-btn shadow-sm rounded-3">Explore More</a>
          </div>
        </div>
        <div class="container mt-5" id="knowledgehub-cards">
<div class="small-cards-wrapper ">

  <!-- Card 1 -->
  <div class="small-card">
    <p class="fw-bold mb-1">122</p>
    <p class="text-xxs mb-2">Total Indicators.</p>
  </div>

  <!-- Card 2 -->
  <div class="small-card">
    <p class="fw-bold mb-1">E-Library</p>
    <p class="text-xxs mb-2">Reporting Departments.</p>
  </div>

  <!-- Card 3 -->
  <div class="small-card">
    <p class="fw-bold mb-1">3</p>
    <p class="text-xxs mb-2">Strategic Tracks.</p>
  </div>

  <!-- Card 4 -->
  <div class="small-card">
    <p class="fw-bold mb-1">10</p>
    <p class="text-xxs mb-2">Pillars Monitored.</p>
  </div>

</div>

</div>

      </div>
    </div>
  </section>

  <section class="gender-mainstreaming mb-3 mt-5">

    <div class="text-center mb-4">
      <h4 class="mb-2 fw-bold">Who We Serve</h4>
      <p class="mb-0">Tailored access for different stakeholder groups</p>
    </div>

    <div class="container-fluid px-5">
      <div class="row align-items-center">
        <!-- Cards Section - Full width on mobile, half on desktop -->
     <div class="col-12 col-lg-12 mb-4 mb-lg-0">
  <div class="row g-3">
    <!-- Card 1 -->
    <div class="col-6 col-sm-6 col-lg-6">
      <div class="dwypd-card h-100 d-flex flex-column text-start text-xs p-4">
        <div class="icon orange-bg mb-4 justify-content-center align-items-center d-flex">
          <i class="bi bi-shield-fill-check fs-6"></i>
        </div>

        <p class="mb-1 fw-bold">Government<br>Public Servants</p>
        <p class="text-xxs mb-0">
          Access reporting tools, submit data, and track departmental performance
        </p>
      </div>
    </div>

    <!-- Card 2 -->
    <div class="col-6 col-sm-6 col-lg-6">
      <div class="dwypd-card active h-100 d-flex flex-column  text-xs text-start p-4">
        <div class="icon orange-bg mb-4 justify-content-center align-items-center d-flex">
          <i class="bi bi-person fs-6"></i>
        </div>
        <p class="mb-1 fw-bold">Academics &<br>Researchers</p>
        <p class="text-xxs mb-0">
          Access research tools and data insights for studies and publications
        </p>
      </div>
    </div>

    <!-- Card 3 -->
    <div class="col-6 col-sm-6 col-lg-6">
      <div class="dwypd-card active h-100 d-flex flex-column  text-xs text-start p-4">
        <div class="icon orange-bg mb-4 justify-content-center align-items-center d-flex">
          <i class="bi bi-graph-up fs-6"></i>
        </div>
        <p class="mb-1 fw-bold text-xs">Non-Profits &<br>Advocacy Groups</p>
        <p class="text-xxs mb-0">
          Use the platform for monitoring, reporting, and advocacy purposes
        </p>
      </div>
    </div>

    <!-- Card 4 -->
    <div class="col-6 col-sm-6 col-lg-6">
      <div class="dwypd-card h-100 d-flex flex-column text-xs p-4 text-start">
        <div class="icon orange-bg mb-4 justify-content-center align-items-center d-flex">
          <i class="bi bi-building fs-6"></i>
        </div>
        <p class="mb-1 fw-bold text-xs">Corporate & For-<br>Profit Organisations</p>
        <p class="text-xxs mb-0">
          Collaborate, submit reports, and analyze departmental performance
        </p>
      </div>
    </div>
  </div>
</div>
 

      </div>
    </div>
  </section>


  <section class="mt-4" id="knowledgehub-cards">

    <div class="">
      <div class="d-none mb-5">
        <h2 class="section-title-census mb-0">The Knowledge Hub</h2>
        <p class="mt-0">Integrated Knowledge Hub for Women, Youth and Persons with Disabilities</p>
      </div>

      <div class="p-3 ms-4">
        <h2 class="section-title-census">Knowledge Resources</h2>
        <p class="text-xs">Tools and materials to support your work

        </p>
      </div>
      <div class="position-relative dwypd-arrows" id="">

        <section class="cards-mainstreaming mb-3">
          <div class="container">
            <div class="row g-3">

              <div class="col-12 col-md-6">
                <div class="dwypd-card h-100 position-relative text-start p-4">
                  <i class="bi bi-journal-bookmark fs-2 mb-3 in-icon"></i>
                  <p class="mb-2 fw-bold">E-Learning</p>
                  <span class="card-badge">Courses</span>
                  <p class="text-xs"> Capacity building courses and training modules </p>
                  <div class="text-start">
                    <a href="/courses" class="view-details btn rounded-3 text-xxs">
                      Explore <i class="bi bi-arrow-right "></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="dwypd-card active h-100 position-relative text-start p-4">
                  <i class="bi bi-book fs-2 mb-3 in-icon"></i>
                  <p class="mb-2 fw-bold text-xs">E-Library</p>
                  <span class="card-badge mt-2">10+ Documents</span>

                  <p class="text-xs">Policy documents, reports and research publications</p>
                  <div class="text-start">
                    <a href="/home" class="view-details btn rounded-3 text-xxs">
                      Explore <i class="bi bi-arrow-right "></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="dwypd-card active h-100 position-relative text-start p-4">
                  <i class="bi bi-calendar-event fs-2 mb-3 in-icon"></i>
                  <p class="mb-2 fw-bold text-xs">Events</p>
                  <span class="card-badge mt-2">Upcoming</span>
                  <p class="text-xs">Workshops, dialogues and national campaigns</p>
                  <div class="text-start ">
                    <a href="/view_events" class="view-details btn rounded-3 text-xxs">
                      Explore <i class="bi bi-arrow-right "></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="dwypd-card h-100 position-relative text-start p-4">
                  <i class="bi bi-clipboard-check fs-2 mb-3 in-icon"></i>
                  <p class="mb-2 fw-bold text-xs">Assessment Tools</p>
                  <span class="card-badge mt-2">15 + Tools</span>
                  <p class="text-xs">Data collection instruments and templates</p>
                  <a href="/assessment_tools" class="view-details btn text-xxs">Explore
                    <i class="bi bi-arrow-right "></i>
                  </a>
                </div>
              </div>


              <div class="col-12 col-md-6">
                <div class="dwypd-card h-100 position-relative text-start p-4">
                  <i class="bi bi-bar-chart-line fs-2 mb-3 in-icon"></i>
                  <p class="mb-2 fw-bold text-xs">M&E Insights</p>
                  <span class="card-badge mt-2">Real Time</span>

                  <p class="text-xs">Performance dashboards and analytics</p>
                  <a href="/insights" class="view-details btn text-xxs">Explore
                    <i class="bi bi-arrow-right "></i>
                  </a>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="dwypd-card h-100 active position-relative text-start p-4">
                  <i class="bi bi-briefcase fs-2 mb-3 in-icon"></i>
                  <span class="card-badge mt-2">Open Positions</span>
                  <p class="mb-2 fw-bold text-xs">Careers</p>
                  <p class="text-xs">Employment opportunities and internships</p>
                  <a href="https://recruitment.dwypd.gov.za/" class="view-details btn text-xxs">Explore
                    <i class="bi bi-arrow-right "></i>
                  </a>
                </div>
              </div>


              <div class="col-12 col-md-6">
                <div class="dwypd-card active h-100 position-relative text-start p-4">
                  <span class="card-badge">10+ Tools</span>

                  <i class="bi bi-universal-access fs-2 mb-3 in-icon"></i>
                  <p class="mb-2 fw-bold text-xs"> Disability Tool</p>
                  <p class="text-xxs">Support accessibility, inclusion, and disability-focused planning.</p>
                  <a href="https://monitoring.dwypd.gov.za/" class="view-details btn  text-xxs">Explore
                    <i class="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>


              <div class="col-12 col-md-6">
                <div class="dwypd-card h-100 position-relative text-start align-items-start p-4">

                  <div class="d-flex justify-content-between gap-3">
                    <i class="bi bi-folder-check fs-2 in-icon"></i>
                    <span class="card-badge mt-2">12+ Tools</span>

                  </div>
                  <p class="mb-2 fw-bold text-xs"> Case Tool</p>
                  <p class="text-xxs">Tracking, managing, and reporting on interventions and support cases.</p>
                  <a href="https://disabilitycases.dwypd.gov.za/" class="view-details btn  text-xxs">Explore
                    <i class="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </section>




        <!-- Cards row -->
        <div class="row py-2 d-none">
          <!-- Card 1 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-learning">
              <div class="overlay d-flex align-items-center text-center p-2">
                <p class="description text-start text-xs">
                  The E-Learning platform provides online courses and training programmes designed to empower women,
                  youth, and persons with disabilities.
                </p>
                <a href="/courses" class="view-details rounded-3 mb-2 w-100">Explore <i
                    class="bi bi-arrow-right"></i></a>
              </div>
              <div class="category-label">E-Learning</div>
            </div>
          </div>

          <!-- Card 2 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-library">
              <div class="overlay d-flex align-items-center text-center p-3">
                <p class="description text-start text-xs">
                  Browse our Knowledge Hub digital library, featuring research reports, policy documents, guidelines,
                  and resources to support inclusive development initiatives.
                </p>
                <a href="/home" class="view-details rounded-3 w-100">Explore</a>
              </div>
              <div class="category-label">E-Library</div>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-events">
              <div class="overlay d-flex align-items-center text-center p-3">
                <p class="description text-start text-xs">
                  Discover events, workshops, and community activities hosted by the Department to promote
                  participation, learning, and empowerment across the country.
                </p>
                <a href="/view_events" class="view-details rounded-3 w-100">Explore</a>
              </div>
              <div class="category-label">Events</div>
            </div>
          </div>

          <!-- Card 4 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-assessment-tools">
              <div class="overlay d-flex align-items-center text-center p-3">
                <p class="description text-start text-xs">
                  Access a variety of assessment tools designed to measure skills, knowledge, and progress, supporting
                  informed decision-making and personal development.
                </p>
                <a href="/library" class="view-details rounded-3 w-100">Explore</a>
              </div>
              <div class="category-label">Assessment Tools</div>
            </div>
          </div>

          <!-- Card 5 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-insights">
              <div class="overlay d-flex align-items-center text-center p-3">
                <p class="description text-start text-xs">
                  Access monitoring and evaluation insights to track program impact, measure progress, and inform policy
                  decisions for the empowerment of women, youth, and persons with disabilities.
                </p>
                <a href="/insights" class="view-details rounded-3 w-100">Explore</a>
              </div>
              <div class="category-label">M&E Insights</div>
            </div>
          </div>

          <!-- Card 6 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-careers">
              <div class="overlay d-flex align-items-center text-center p-3">
                <p class="description text-start text-xs">
                  Access recruitment opportunities, internships, and development programmes supporting employment and
                  skills development for women, youth, and persons with disabilities.
                </p>
                <a href="https://recruitment.dwypd.gov.za/" class="view-details rounded-3 w-100">Explore</a>
              </div>
              <div class="category-label">Careers</div>
            </div>
          </div>

          <!-- Card 7 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-disability-tool">
              <div class="overlay d-flex align-items-center text-center p-3">
                <p class="description text-start text-xs">
                  Explore our network of partners and collaborators driving initiatives for inclusive development.
                </p>
                <a href="/partners" class="view-details rounded-3 w-100">Explore</a>
              </div>
              <div class="category-label">Disability Tool</div>
            </div>
          </div>

          <!-- Card 8 -->
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="category-card bg-case">
              <div class="overlay d-flex align-items-center text-center p-3">
                <p class="description text-start text-xs">
                  Stay updated with the latest news, announcements, and stories about our programs and community impact.
                </p>
                <a href="/news" class="view-details rounded-3 w-100">Explore</a>
              </div>
              <div class="category-label">Case Tool</div>
            </div>
          </div>
        </div>


      </div>


    </div>
  </section>

  <div class="footer-background">
    <div class="space"></div>
    <footer class="footer-content text-white pt-5 pb-4">
      <div class="container text-center text-md-left">
        <div class="row text-center text-md-left">
          <div class="col-md-3 col-lg-3 col-xl-3 mx-auto">
            <h5 class="text-start font-weight-bold knowledgehub2 ">Services</h5>
            <br>
            <a href="https://recruitment.dwypd.gov.za/" class="text-start d-block text-white text-decoration-none mb-4">Careers</a>
            <a href="https://dwypd.gov.za/" class="text-start d-block text-white text-decoration-none mb-4">Government</a>
            <a href="https://sayouth.mobi/Home/Index/EN" class="text-start d-block text-white text-decoration-none mb-4">SA Youth</a>
            <a href="#" class="text-start d-block text-white text-decoration-none mb-4">Votes</a>
          </div>
          <div class="col-md-3 col-lg-2 col-xl-2 mx-auto">
            <h5 class="text-start font-weight-bold knowledgehub2">Get in touch</h5>
            <br>
            <a href="#" class="text-start d-block text-white text-decoration-none mb-4" target="_blank">Fedsure Forum
              Building<br>1st Floor <br>
              268 Lilian Ngoyi Street <br> Pretoria 0001 South Africa</a>
            <a href="tel:+27123590000" class="text-start d-block text-white text-decoration-none mb-4"> 012 359 0000
            </a>
            <a href="mailto:media@dwypd.gov.za" class="text-start d-block text-white text-decoration-none mb-4">Email Us
              : media@dwypd.gov.za</a>
          </div>

        </div>
        <hr class="mb-2">
        <div class="row align-items-center">
          <div class="text-center">
            <p>
              Copyright © 2026 All rights reserved by
              <strong>
                <a href="https://engagenet.ai/" target="_blank" class="text-white">Engagenet</a>
              </strong>.
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</div>
